import Ad from "@components/Advertisement/Ad";
import Container from "@components/Container/Container";
import { GADataProps } from "@components/GAData/GAData";
import EventsAwardsHeader from "@events-awards/components/EventAwardsHeader";
import EventsAwardsNavigationBar from "@events-awards/components/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import LandingPageArticle from "@events-awards/components/LandingPageArticle";
import {
  AwardType,
  EventsAwardsLandingPageData,
} from "@events-awards/utils/types";
import { useInjectClientData } from "@hooks/useInjectClientData";
import SCADescription from "@sca/components/SCADescription";
import SCAFooter from "@sca/components/SCAFooterComponents/SCAFooter";
import SCANominationsDescription from "@sca/components/SCANominationsDescription";
import SCAOrganiserDetails from "@sca/components/SCAOrganiserDetails";

/**
 * Component to render SCA page
 */
const EventsAwardsSCAPageContent = ({
  articleProps,
  gaProps,
}: EventsAwardsLandingPageData & {
  gaProps: GADataProps;
}): React.ReactElement => {
  useInjectClientData({ gaProps });

  return (
    <div
      className="w-full"
      data-testid="events-awards-sca-page-content-component"
    >
      <EventsAwardsHeader />

      <Container>
        <EventsAwardsNavigationBar awardType={AwardType.SCA} />
      </Container>

      {articleProps ? (
        <div className="mb-6 bg-gray-150">
          <Container rootClassName="px-0 lg:px-3">
            <LandingPageArticle articleProps={articleProps} />
          </Container>
        </div>
      ) : null}

      <SCADescription />

      <div className="mt-1 bg-gray-150 px-3 py-8 md:px-6 lg:px-0">
        <Container>
          <SCANominationsDescription />
        </Container>
      </div>

      <SCAOrganiserDetails />

      <SCAFooter />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default EventsAwardsSCAPageContent;
